import { HTMLAttributes } from 'react'
import { cva, VariantProps } from 'class-variance-authority'

import Section from '@/components/base/section'

import { cn } from '@/lib/utils'

const spacerVariants = cva(['border-0 '], {
  variants: {
    variant: {
      xxs: 'pt-s-spacer-xxs md:pt-d-spacer-xxs',
      xs: 'pt-s-spacer-xs md:pt-d-spacer-xs',
      sm: 'pt-s-spacer-sm md:pt-d-spacer-sm',
      md: 'pt-s-spacer-md md:pt-d-spacer-md',
      lg: 'pt-s-spacer-lg md:pt-d-spacer-lg',
      xl: 'pt-s-spacer-xl md:pt-d-spacer-xl',
      '2xl': 'pt-s-spacer-2xl md:pt-d-spacer-2xl'
    },
    spacer: {
      single: 'pt-s-spacer-2xl md:pt-d-spacer-2xl',
      double: 'pt-d-spacer-2xl md:pt-[19.2rem]'
    }
  },
  defaultVariants: {
    variant: '2xl'
  }
})

export type SpacerProps = HTMLAttributes<HTMLHRElement> &
  VariantProps<typeof spacerVariants> & {
    transparent?: boolean
    [key: string]: any
  }

const Spacer = ({ className, variant, ...props }: SpacerProps) => {
  const safeProps = Object.entries(props).reduce(
    (acc, [key, value]) => {
      if (!key.startsWith('acfe_') && (key.startsWith('data-') || !key.includes('_'))) {
        acc[key] = value
      }
      return acc
    },
    {} as Record<string, any>
  )

  return (
    <Section
      asChild
      className={cn(spacerVariants({ variant, className }))}
      {...safeProps}
      data-spacer={variant}
    >
      <hr />
    </Section>
  )
}

export default Spacer
